module.exports = __webpack_public_path__ + "img/w9-cover.c85e8884.jpg";